import FormControlLabel, { FormControlLabelProps } from '@mui/material/FormControlLabel';
import React from 'react';
import { Checkbox, CheckboxProps } from '../checkbox/index';

export type LabeledCheckboxProps = Omit<FormControlLabelProps, 'control' | 'defaultChecked'> & {
	checkboxProps?: Omit<CheckboxProps, 'edge'>;
};

/**
 * A convenience component, comprising of a Mui `FormControlLabel` with a control of `Checkbox`.
 * For the most part, `LabeledCheckbox` has the same behavior as a regular `Checkbox`.
 * Accessibility concerns will be handled automatically when passing the `label` prop a string.
 */
export const LabeledCheckbox = React.forwardRef<HTMLLabelElement, LabeledCheckboxProps>(({ checkboxProps, ...props }, ref) => {
	const allCheckboxProps = checkboxProps ?? {};
	if (typeof props.label === 'string') allCheckboxProps.inputProps = { ...allCheckboxProps?.inputProps, ['aria-label']: props.label };
	return <FormControlLabel ref={ref} control={<Checkbox {...allCheckboxProps} />} {...props} />;
});
